import { css } from '@emotion/react';
import { styles } from '../../../styles';

export const modalHelperTextStyles = ({ color, spacing }) => css`
  ${styles.truncate};
  grid-area: middle;
  margin: ${spacing(0, 1)};
  color: ${color};
`;
